import { Chip, createStyles, withStyles } from '@material-ui/core';
import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { get } from 'lodash';
import lottie, { AnimationItem } from 'lottie-web';
import lottieScale from 'lottie-scale/dist';

import TrackingLoading from '../../assets/general/animations/TrackingLoading.json';

const styles = (theme) =>
  createStyles({
    chip: {
      height: 18,
      fontSize: 12,
      fontWeight: 'bold',
    },
    loadingChip: {
      '& .MuiChip-label': {
        padding: 0,
      },
    },
    labelContainer: {
      display: 'flex',
      alignItems: 'center',
    },
  });

const StatusField = ({
  classes,
  className = '',
  record = {},
  basePath = '',
  translateChoice,
  resource,
  markedAsShipped = false,
  trackingLoading = false,
  ...props
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const animationRef = useRef<AnimationItem | null>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    const animation = lottie.loadAnimation({
      loop: true,
      autoplay: false,
      animationData: TrackingLoading,
      container,
      rendererSettings: {
        preserveAspectRatio: 'xMinYMin meet',
      },
    });

    const handleDomLoaded = () => {
      lottieScale(20, container);
    };

    animation.addEventListener('DOMLoaded', handleDomLoaded);
    animationRef.current = animation;

    return () => {
      animation.removeEventListener('DOMLoaded', handleDomLoaded);
      animation.destroy();
      animationRef.current = null;
    };
  }, []);

  useEffect(() => {
    const animation = animationRef.current;
    if (!animation) {
      return;
    }

    if (trackingLoading) {
      animation.goToAndPlay(0, true);
    } else {
      animation.stop();
      animation.goToAndStop(0, true);
    }
  }, [trackingLoading]);

  return (
    <Chip
      className={classNames(classes.chip, className, trackingLoading && classes.loadingChip)}
      style={{
        backgroundColor: get(record, 'bgColor'),
        color: get(record, 'color'),
      }}
      label={
        <div className={classes.labelContainer}>
          <div
            ref={containerRef}
            style={{
              display: !trackingLoading ? 'none' : 'block',
            }}></div>
          {!trackingLoading && (!markedAsShipped ? get(record, 'name') : 'Marked As Shipped')}
        </div>
      }
      {...props}
    />
  );
};

export default withStyles(styles)(StatusField);
